// =============================================================================
// ESPOLIDAR WEB ADMIN - STATISTICS HOOKS
// =============================================================================

import { useQuery } from '@tanstack/react-query'
import { eventsApi } from '../services/api'
import type { GlobalStats, TimelineStats, TopZonesStats } from '../types'

/**
 * Hook per statistiche globali (tutti i dispositivi del reseller)
 */
export function useGlobalStats(days: number = 7) {
  return useQuery<GlobalStats>({
    queryKey: ['globalStats', days],
    queryFn: () => eventsApi.getGlobalStats(days),
    staleTime: 60000, // 1 minuto
    refetchInterval: 60000, // Aggiorna ogni minuto
  })
}

/**
 * Hook per timeline (trend temporale)
 */
export function useTimelineStats(params?: {
  device_id?: string
  days?: number
  bucket?: 'day' | 'hour'
}) {
  const { device_id, days = 7, bucket = 'day' } = params || {}

  return useQuery<TimelineStats>({
    queryKey: ['timelineStats', device_id, days, bucket],
    queryFn: () => eventsApi.getTimelineStats({ device_id, days, bucket }),
    staleTime: 60000,
    refetchInterval: 60000,
  })
}

/**
 * Hook per top zone attivate
 */
export function useTopZones(params?: {
  device_id?: string
  days?: number
  limit?: number
}) {
  const { device_id, days = 7, limit = 10 } = params || {}

  return useQuery<TopZonesStats>({
    queryKey: ['topZones', device_id, days, limit],
    queryFn: () => eventsApi.getTopZones({ device_id, days, limit }),
    staleTime: 60000,
    refetchInterval: 60000,
  })
}
